import ISet from "./ISet";

export const contains = (event, emission) =>
  ISet.load(emission.primedEvents).has(event) ||
  ISet.load(emission.firedEvents).has(event);
